module.exports = __webpack_public_path__ + "img/profile-pic-tourist.886d902e.jpg";